import { assetUrl } from "@/lib/api";
import { useBrand } from "@/context/BrandContext";

export const Logo = ({ edition, className = "h-9", testId = "brand-logo" }) => {
  const { theme } = useBrand();
  if (!edition) return null;
  const src = assetUrl(edition.logo_url);
  const square = edition.logo_shape === "square";
  if (!src) {
    return (
      <span data-testid={testId} className="font-heading text-lg font-black tracking-tight">
        {edition.brand_name}
      </span>
    );
  }
  return (
    <span data-testid={testId} className="inline-flex items-center gap-2.5">
      <span className={theme === "dark" && square ? "rounded-sm bg-white p-0.5" : ""}>
        <img src={src} alt={`${edition.brand_name} logo`} className={`${className} w-auto object-contain`} />
      </span>
      {square && <span className="font-heading text-lg font-black tracking-tight">{edition.brand_name}</span>}
    </span>
  );
};
